document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('copy-clipboard-button').addEventListener('click', function() {
      const shareUrl = document.getElementById('copy-clipboard-url');
      const tempInput = document.createElement('input');
      document.body.appendChild(tempInput);
      tempInput.value = shareUrl.textContent;
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
    });
  });
  